import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import { ButtonV2 } from 'builder/components/Button'

export const NavigationSectionContainer = styled.div`
  position: fixed;
  bottom: 0;
  width: 50%;
  display: flex;
  flex-direction: column;
  padding: 36px 36px 16px;
  background-color: ${Colors.White};
  border-radius: 12px 12px 0 0;
  margin-top: 4px;
  justify-content: space-between;
  z-index: 1;

  ${Media.Phone`
      width: 100%;
      padding: 36px 12px ${Spacing.S};
      flex-direction: column;
      gap: ${Spacing.L};
  `}

  ${Media.Tablet`
      width: 100%;
  `}

  ${Media.Laptop`
    width: 100%;
  `};

  ${Media.Desktop`
    max-width: 860px;
  `};
`

export const BackContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${Spacing.M};

  &:empty {
    display: none;
  }
`

export const NextContainer = styled.div`
  ${Media.Phone`
    flex: 1 1 auto;
  `}
`

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  ${Media.Phone`
    gap: ${Spacing['2XS']};
    flex-wrap: wrap;
  `}
`

export const BackButton = styled(ButtonV2)`
  ${Media.Phone`
    width: 64px;
  `}
`

export const NextButton = styled(ButtonV2)`
  ${Media.Phone`
    width: -webkit-fill-available;
  `}
`

export const NavigationBorder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  background-color: #eff2f9;
  position: absolute;
  top: 0;
  left: 0;
`

export const BorderTop = styled.div`
  width: 100%;
  border-bottom: 12px solid white;
  border-radius: 0 0 12px 12px;
`

export const BorderBottom = styled.div`
  width: 100%;
  border-top: 12px solid white;
  border-radius: 12px 12px 0 0;
`
